import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { SearchSharp } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";
import { useTheme } from "@emotion/react";

export default function AeropayTxFilters({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  loading,
  exportLoading,
  onFilter,
  onExport,
}) {
  const theme = useTheme();
  const invalidRange = !!startDate && !!endDate && dayjs(startDate).isAfter(endDate);

  const datePickerSx = {
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#fff" },
      "&:hover fieldset": { borderColor: "#fff" },
      "&.Mui-focused fieldset": { borderColor: "#fff" },
    },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#fff !important" },
    "& .MuiInputBase-input": { color: "#000" },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={setStartDate}
          renderInput={(params) => (
            <TextField
              {...params}
              error={invalidRange}
              helperText={invalidRange ? "Start date cannot be after End date" : ""}
            />
          )}
          sx={datePickerSx}
          maxDate={dayjs()}
        />

        <DatePicker
          label="End Date"
          value={endDate}
          onChange={setEndDate}
          renderInput={(params) => (
            <TextField
              {...params}
              error={invalidRange}
              helperText={invalidRange ? "End date cannot be before Start date" : ""}
            />
          )}
          sx={datePickerSx}
          maxDate={dayjs()}
        />

        <Box display="flex" gap={2} flexWrap="wrap">
          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchSharp />}
            onClick={onFilter}
            disabled={loading || invalidRange}
            sx={{ height: 56, px: 3, fontWeight: 600, textTransform: "none", whiteSpace: "nowrap" }}
          >
            Filter
          </Button>

          <Button
            variant="contained"
            startIcon={exportLoading ? <CircularProgress size={18} color="inherit" /> : <DownloadIcon />}
            disabled={exportLoading || loading || !startDate || !endDate || invalidRange}
            onClick={onExport}
            sx={{
              height: 56,
              px: 3,
              fontWeight: 600,
              textTransform: "none",
              whiteSpace: "nowrap",
              background: `linear-gradient(90deg, ${theme.bulaYellow} 0%, ${theme.bulaOrange} 100%)`,
              color: "#fff",
              boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
              "&:hover": {
                background: `linear-gradient(90deg, ${theme.bulaOrange} 0%, ${theme.bulaYellow} 100%)`,
              },
            }}
          >
            Export to CSV
          </Button>
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
